import Fingerprint2 from 'fingerprintjs2';

export default class IdentityService {
  static initialise(){
    return new Promise(function(resolve, reject) {
      if (window.requestIdleCallback) {
          requestIdleCallback(() => {
            IdentityService._generateFingerprint((fingerprint)=>{
              resolve(fingerprint);  
            });
          })
        } else {
          setTimeout(() => {
            IdentityService._generateFingerprint((fingerprint)=>{
              resolve(fingerprint);  
            });
          }, 500)
        }
    });
  }
    
  static _generateFingerprint(callback){
    Fingerprint2.get((components) => {
      this.fingerprint = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31);
      
      if(callback){
        callback(this.fingerprint);
      }
    })
  }   

  static getFingerprint(){
    return this.fingerprint;
  }
}